export type RoundResult = {
  score: number;
  accuracy: number;
  hits: number;
  misses: number;
  shotsFired: number;
  reloads: number;
  durationMs: number;
  themeId: string;
  themeVersion: string;
  targetHits: Record<string, number>;
};

export const ROUND_COMPLETE_EVENT = "moormenners:round-complete";
export const ROUND_EXIT_EVENT = "moormenners:round-exit";
export const ROUND_READY_EVENT = "moormenners:round-ready";
